import Log from './log-container';

export default Log;
